module.exports = __webpack_public_path__ + "assets/img/2.633da212.png";